var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonUsers = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M9 13.18a7.18 7.18 0 1114.362.002A7.18 7.18 0 019 13.18z", fill: fills.dark }),
        React.createElement("path", { d: "M6.283 25.545a7.797 7.797 0 015.515-2.283H20a7.797 7.797 0 017.798 7.798v7.814A3.125 3.125 0 0124.672 42H7.126A3.127 3.127 0 014 38.874V31.06c0-2.068.822-4.052 2.283-5.515zM31.507 27.47a5.135 5.135 0 013.633-1.505h3.722A5.135 5.135 0 0144 31.103v4.836C44 37.077 43.077 38 41.94 38h-9.88A2.061 2.061 0 0130 35.94v-4.837a5.16 5.16 0 011.507-3.633z", fill: fills.light }),
        React.createElement("path", { d: "M32 19a5.001 5.001 0 0110 0 5.001 5.001 0 01-10 0z", fill: fills.base })));
}, {
    name: identiconComponentName,
})({});
